export default "__VITE_ASSET__B4avC$FM__"